<template>
    <div class="o-step-icon">
        <img
            :src="src"
            class="step-icon-image"
        >
    </div>
</template>

<script>
import {
    mapState,
    mapGetters
} from 'vuex';

export default {
    name: "OStepIcon",
    props: {
        step: {
            type: Object,
            required: true
        },
        item: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    },
    computed: {
        ...mapState({
            activePath: state => state.activePath,
            activeStep: state => state.activeStep,
            activeStepIndex: state => state.activeStepIndex
        }),
        ...mapGetters([
            't',
            'getMapConfigProp'
        ]),
        isOutdoorStep(){
            return this.index === _.get(this.activePath,'steps.length',0)-1 && this.t(this.item, 'is_google_maps');
        },
        src() {
            const stepIcon = _.get(this.step, 'type','walk').toLowerCase();
            const isDoors = this.step.type.toLowerCase() === 'doors';

            if (this.item?.files?.icon && this.index + 1 === this.activePath?.steps.length) {
                return this.item.files.icon || this.item.files.logo;
            } else if (this.index === 0 && this.activeStepIndex !== this.index) {
                return this.getMapConfigProp('step_icons.start_step_icon');
            } else if (this.index === 0 && this.activeStepIndex === 0) {
                return this.getMapConfigProp('step_icons.start_step_icon_inverted');
            } else if (this.isOutdoorStep) {
                return this.getMapConfigProp('step_icons.google_maps_icon');
            } else if (isDoors) {
                return this.getMapConfigProp(`step_icons.doors-${this.step.direction}`);
            } else {
                return this.getMapConfigProp(`step_icons.${stepIcon}`);
            }
        }
    }
}
</script>

<style lang="scss">
@import "theme";
</style>
